import React from "react";
import { Share2 } from "lucide-react";
import { GetBattleByIdApiResponse as Battle } from "@dripit/types";

import {
  Dialog,
  DialogContent,
  DialogTrigger,
  Drawer,
  DrawerContent,
  DrawerTrigger,
} from "@/components/ui";
import { useBreakpoints, useTranslate } from "@/hooks";
import { ShareBattleDialogContent } from "./ShareBattleDialogContent";

interface ShareBattleDialogProps {
  triggerButton?: React.ReactNode;
  battle?: Battle;
}

export const ShareBattleDialog: React.FC<ShareBattleDialogProps> = ({
  triggerButton,
  battle,
}) => {
  const t = useTranslate();
  const { isGreaterThan } = useBreakpoints();
  const [open, setOpen] = React.useState(false);

  if (!isGreaterThan("md")) {
    return (
      <Drawer open={open} onOpenChange={setOpen}>
        <DrawerTrigger asChild>
          {triggerButton ?? (
            <button className="inline-flex h-10 items-center justify-center rounded-full border border-slate-300 p-3 text-base text-slate-300 lg:px-6 xl:px-8 xl:text-xl">
              <Share2 className="mr-2 inline-block size-5" />
              {t("components.share")}
            </button>
          )}
        </DrawerTrigger>
        <DrawerContent
          className="h-[90vh] bg-slate-800 px-4"
          aria-describedby="share-battle-drawer">
          <div className="scrollbar-hide h-full overflow-y-auto">
            <ShareBattleDialogContent
              isDrawer
              battle={battle}
              onClose={() => setOpen(false)}
            />
          </div>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {triggerButton ?? (
          <button className="inline-flex h-10 items-center justify-center rounded-full border border-slate-300 p-3 text-base text-slate-300 lg:px-6 xl:px-8 xl:text-xl">
            <Share2 className="mr-2 inline-block size-5" />
            {t("components.share")}
          </button>
        )}
      </DialogTrigger>
      <DialogContent
        className="md:max-w-2xl lg:max-w-4xl"
        aria-describedby="share-battle-dialog">
        <ShareBattleDialogContent
          battle={battle}
          onClose={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
};
